export const apiRoutes = {
  api_r_user_module_comsaReports_report: {
    path: 'm/comsa-reports/report/',
  },
  api_r_user_module_comsaReports_reportOptions: {
    path: 'm/comsa-reports/report-options/',
  },
  api_r_user_module_comsaReports_addReport: {
    path: 'm/comsa-reports/add-report/',
  },
  api_r_user_module_comsaReports_editReport: {
    path: 'm/comsa-reports/edit-report/',
  },
  api_r_user_module_comsaReports_removeReport: {
    path: 'm/comsa-reports/remove-report/',
  },
  api_r_user_module_comsaReports_getFile: {
    path: 'm/comsa-reports/get-file/',
  },
  api_r_user_module_comsaReports_manager_file_get: {
    path: 'm/comsa-reports/get-manager-file/',
  },
  api_r_user_module_comsaReports_getWasteBooks: {
    path: 'm/comsa-reports/get-waste-books/',
  },
  api_r_user_module_comsaReports_getWasteBookLink: {
    path: 'm/comsa-reports/get-waste-book-link/',
  },
  api_r_user_module_comsaReports_editWasteBook: {
    path: 'm/comsa-reports/edit-waste-book/',
  },
  api_r_user_module_comsaReports_manager_list: {
    path: 'm/comsa-reports/manager/list/',
  },
  api_r_user_module_comsaReports_manager_get: {
    path: 'm/comsa-reports/manager/get/',
  },
  api_r_user_module_comsaReports_manager_edit: {
    path: 'm/comsa-reports/manager/edit/',
  },
  api_r_user_module_comsaReports_manager_delete: {
    path: 'm/comsa-reports/manager/delete/',
  },
  api_r_user_module_comsaReports_getModuleData: {
    path: 'm/comsa-reports/get-module-data/',
  },
  api_r_user_module_comsaReports_getObservations: {
    path: 'm/comsa-reports/get-observations/',
  },
  api_r_user_module_comsaReports_setObservations: {
    path: 'm/comsa-reports/set-observations/',
  },
  api_r_user_module_comsaReports_getXlsReport: {
    path: 'm/comsa-reports/get-xls-report/',
  },
  api_r_user_module_comsaReports_getXlsReport2: {
    path: 'm/comsa-reports/get-xls-report-2/',
  },
  api_r_user_module_comsaEnvironmental_dataInput: {
    path: 'm/comsa-reports/get-xls-construction-report/',
  },
  api_r_user_module_comsaEnvironmental_downloadXlsPpiReport: {
    path: 'm/comsa-reports/download-xls-ppi-report/',
  },
  api_r_user_module_comsaReports_getLandUseFromPlantsEvidence: {
    path: 'm/comsa-reports/get-land-use-from-plant-evidence/',
  },
  api_r_user_module_comsaReports_getLandUseInPlantsEvidence: {
    path: 'm/comsa-reports/get-land-use-in-plant-evidence/',
  },
  api_r_user_module_comsaReports_getWaterWasteEvidence: {
    path: 'm/comsa-reports/get-water-waste-evidence/',
  },
  api_r_user_module_comsaReports_getWasteManagementCodes: {
    path: 'm/comsa-reports/get-waste-management-codes/',
  },
};
